export class ListeChoix {
    constructor(
        public id?: number,
        public code?: string,
        public libelle?: string,
        public libelleEn?: string,
        public ordre?: number,
        public actif?: boolean
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/ListeChoix/listeChoix.model.ts